import BrandsCenteredContent from 'components/BrandsCenteredContent';
import Skeleton from 'components/Skeleton';

import useStyles from './styles';

const WithUsSkeleton = () => {
  const classes = useStyles();

  return (
    <div data-testid="withUs-skeleton-wrapper">
      <BrandsCenteredContent>
        <Skeleton height={20} className={classes.skeletonTitle} />
        <div className={classes.skeletonRoot}>
          <Skeleton height={18} className={classes.description} />
          <div className={classes.skeletonFlex}>
            <Skeleton height={30} className={classes.skeletonLinks} />
            <Skeleton height={30} className={classes.skeletonLinks} />
            <Skeleton height={30} className={classes.skeletonLinks} />
          </div>
        </div>
      </BrandsCenteredContent>
    </div>
  );
};

export default WithUsSkeleton;
